import { render, staticRenderFns } from "./SectionCard.vue?vue&type=template&id=cc8eb95e&scoped=true"
import script from "./SectionCard.vue?vue&type=script&lang=js"
export * from "./SectionCard.vue?vue&type=script&lang=js"
import style0 from "./SectionCard.vue?vue&type=style&index=0&id=cc8eb95e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8eb95e",
  null
  
)

export default component.exports